import { UPLOAD_FILE_STATUS } from '../types';
import { fileValidation } from '../utils/constants';

const { VALID } = fileValidation;

const initialState = {
  ids: [],
  files: {},
  uploadStatus: VALID,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPLOAD_FILE_STATUS:
      return {
        ...state,
        uploadStatus: action.payload,
      };
    default:
      return state;
  }
};
